export const FUTCOM_QUANTITY_STEPS = {
  COPPER: 25,
  NATURALGAS: 125,
  NATGASMINI: 25,
  LEADMINI: 10,
  ZINCMINI: 10,
};

export const FUTCOM_LOT_QTY_STEP_FULL = 'full_lot';
export const FUTCOM_LOT_QTY_STEP_DECIMAL = 'decimal_lot';

export const resolveFutComQuantityStep = (name) => {
  const key = String(name || '').trim().toUpperCase();
  if (FUTCOM_QUANTITY_STEPS[key]) return FUTCOM_QUANTITY_STEPS[key];
  const token = key.split(/[\s_-]+/)[0];
  return FUTCOM_QUANTITY_STEPS[token] || 1;
};

export const isFutComDecimalLotStep = (userDetails) => {
  return String(userDetails?.FUTCOM_lot_qty_step_type || FUTCOM_LOT_QTY_STEP_DECIMAL)
    .trim()
    .toLowerCase() !== FUTCOM_LOT_QTY_STEP_FULL;
};

export const resolveFutComLotQtySteps = ({
  exchange,
  scriptName,
  lotSize,
  userDetails,
} = {}) => {
  const isFutCom = String(exchange || '') === 'FUTCOM';
  if (!isFutCom) {
    return {
      isFutCom: false,
      isDecimalLotStep: false,
      lotStep: 1,
      minLots: 1,
      quantityStep: 1,
      minQuantity: 1,
    };
  }

  const decimal = isFutComDecimalLotStep(userDetails);
  if (decimal) {
    const quantityStep = resolveFutComQuantityStep(scriptName);
    return {
      isFutCom: true,
      isDecimalLotStep: true,
      lotStep: 0.10,
      minLots: 0.10,
      quantityStep,
      minQuantity: quantityStep,
    };
  }

  return {
    isFutCom: true,
    isDecimalLotStep: false,
    lotStep: 1,
    minLots: 1,
    quantityStep: 1,
    minQuantity: 1,
  };
};
